import { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Authorize, GlobalButton, NavigateLinks } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import {
  Add as AddIcon,
  AssignmentOutlined as AssignmentIcon,
  RocketLaunchOutlined as RocketLaunchIcon,
} from '@mui/icons-material';
import { INTEGRATION_REQUEST_ROLES, INTEGRATION_REQUESTS_TITLE } from './pages/IntegrationRequests';
import { commercePageBreadcrumbs } from './config/breadcrumbs';
import { CommercesSearchBar, CommercesTable } from './components';
import { useCommercesExport, useCommercesFilter } from './hooks';
import { CommerceFilters } from './models';

const Commerce = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => commercePageBreadcrumbs(navigate).slice(0, -1),
    [navigate]
  );
  const { filters, setFilters, initialFilter } = useCommercesFilter();
  const { exportCommerces, isExporting } = useCommercesExport();

  const handleSearch = useCallback(
    (searchFilters: CommerceFilters) => {
      setFilters(searchFilters);
      const url = new URL(window.location.href);
      url.searchParams.set('page', '1');
      window.history.replaceState({}, '', url.toString());
    },
    [setFilters]
  );

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks actualPage='Comercios' breadcrumbs={breadcrumbs} />
      <Authorize permission={[...BUSINESS_ROLE_GROUPS.operations, ...INTEGRATION_REQUEST_ROLES]}>
        <div className='flex gap-2.5 justify-end'>
          <Authorize permission={INTEGRATION_REQUEST_ROLES}>
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={() => navigate('integration-requests')}
            >
              <AssignmentIcon />
              {INTEGRATION_REQUESTS_TITLE}
            </GlobalButton>
          </Authorize>
          <Authorize permission={BUSINESS_ROLE_GROUPS.management}>
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={() => navigate('integration')}
            >
              <RocketLaunchIcon />
              Integrar comercio
            </GlobalButton>
          </Authorize>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate('new')}
          >
            <AddIcon />
            Nuevo Comercio
          </GlobalButton>
        </div>
      </Authorize>
      <CommercesSearchBar
        initialFilter={initialFilter}
        filter={filters}
        search={handleSearch}
        onExport={() => exportCommerces(filters)}
        isExporting={isExporting}
      />
      <CommercesTable filters={filters} />
    </section>
  );
};

export default Commerce;
